"use strict";const e=13,t=32,o=9;exports.onKeyDownFunction=(n,p)=>{n.keyCode!==o&&(n.keyCode===t?n.preventDefault():n.keyCode===e&&(n.preventDefault(),p&&p()))},exports.onKeyUpFunction=(e,o)=>{e.keyCode===t&&(e.preventDefault(),o&&o())};
